import React from 'react';
import { bool, string, shape, arrayOf, object } from 'prop-types';
import _ from 'lodash';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Button, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import cx from 'classnames';

import styles from './styles';
import { getI18nFormattedMessage } from "../../utils/intl";

const handleDownloadAssets = (url) => {
  // custom function as downloadjs doesn't work properly for urls
  const link = document.createElement('a');
  link.href = url;
  // Add the element to the DOM
  link.setAttribute('type', 'hidden');
  document.body.appendChild(link);
  link.click();
}

export const ApiAssets = (props) => {
  const { api, apiAssets, config, classes, hasTitle = true, link } = props;
  const downloadButtonText = api.apiServiceType === 'REST'
    ? getI18nFormattedMessage('label.api.asset.swagger.download')
    : getI18nFormattedMessage('label.api.asset.download');
  const isGatewayPublishedSoapApi = (api && api.apiServiceType === 'SOAP'
    && !api.publishedByPortal);
  let assetsSection;
  const tenantId = config.portal.tenantPrefix;

  function getAssetLinks(apiAsset) {
    return _.map(apiAsset.links, (assetLink) => (
      <>
      <div className={classes.assetLinkStyle}>
          <Typography
            className={cx('body1', classes.truncateText)}>
            {(isGatewayPublishedSoapApi ? (`${assetLink.href}`)
              : (`${window.location.origin}${assetLink.href}`))}
          </Typography>
          <a
            className={cx(classes.noTextUnderline, classes.assetLinkStyle,
              classes.assetLinkText)}
            href={(isGatewayPublishedSoapApi ? (`${assetLink.href}`)
              : (`/api/${tenantId}${assetLink.href}`))}
          >
            <span>Download</span>
          </a>
      </div>
      </>
    ));
  }

  if (_.isEmpty(apiAssets)) {
    assetsSection = (
      <Typography classes={cx(classes.assetText, classes.truncateText)}>
        {getI18nFormattedMessage('label.api.no.assets')}
      </Typography>
    );
  } else {
    assetsSection = [
      _.map(apiAssets,
        (apiAsset) => (
          <li key={apiAsset.uuid}>
            <Typography variant={'h5'}>
              {apiAsset.name}
            </Typography>
            {getAssetLinks(apiAsset)}
          </li>),
      ),
      _.size(apiAssets) > 1 ?
        <Button key="apiAssetsButton" className={classes.downloadButton}
                onClick={() => handleDownloadAssets(link)}>
          {downloadButtonText}
        </Button> : null];
  }
  return (
    <>
      {hasTitle &&
        <Typography variant="h4">{getI18nFormattedMessage(
          'label.assets')}</Typography>
      }
      <ul>
        {assetsSection}
      </ul>
    </>
  );
}

const mapStateToProps = () => ({});

ApiAssets.propTypes = {
  config: object,
  api: object,
  apiAssets: arrayOf(object),
  tenantId: string,
  classes: shape({}),
  link: string,
  hasTitle: bool,
};
ApiAssets.displayName = 'ApiAssets';

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(ApiAssets);
